import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import api from "../core/api";

export default function AuthGuard({ children }) {
  const [status, setStatus] = useState("loading");
  const [retryKey, setRetryKey] = useState(0);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    async function checkAuth() {
      const token = localStorage.getItem("token");

      if (!token) {
        if (!cancelled) setStatus("guest");
        return;
      }

      try {
        const res = await api.get("/auth/me");
        const data = res.data;

        const userData = data?.user || data;
        if (userData && data?.success !== false) {
          localStorage.setItem("user", JSON.stringify(userData));
          if (!cancelled) setStatus("authed");
        } else {
          if (!cancelled) setStatus("server-error");
        }
      } catch (err) {
        if (!err.response) {
          console.warn("Network error while checking auth:", err);
          if (!cancelled) setStatus("offline");
          return;
        }

        const httpStatus = err.response.status;

        if (httpStatus === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          if (!cancelled) setStatus("guest");
          return;
        }

        console.warn("Server responded with error:", httpStatus);
        if (!cancelled) setStatus("server-error");
      }
    }

    checkAuth();
    return () => {
      cancelled = true;
    };
  }, [retryKey]);

  if (status === "loading") {
    return <LoadingScreen message="در حال بررسی احراز هویت..." />;
  }

  if (status === "offline") {
    return (
      <LoadingScreen
        variant="error"
        title="اتصال اینترنت برقرار نیست"
        message="لطفاً اتصال خود را بررسی کنید و دوباره تلاش کنید."
        onRetry={() => {
          setStatus("loading");
          setRetryKey((k) => k + 1);
        }}
      />
    );
  }

  if (status === "server-error") {
    return (
      <LoadingScreen
        variant="error"
        title="خطا در ارتباط با سرور"
        message="سرور در دسترس نیست. کمی بعد دوباره تلاش کنید."
        onRetry={() => {
          setStatus("loading");
          setRetryKey((k) => k + 1);
        }}
      />
    );
  }

  if (status === "guest") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const u = JSON.parse(localStorage.getItem("user") || "null");
  if (u?.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return children;
}
